(function () {
  // Builds the dot indicators under the main image and keeps them in sync
  // with whichever image is currently active (is-active class), no matter
  // what triggered the change (thumbnail click, arrow click, or swipe).
  function buildDots(mediaGallery, viewer) {
    if (mediaGallery.querySelector('.product-gallery-dots')) return null;

    var slides = viewer.querySelectorAll('.product__media-list > .slider__slide');
    if (slides.length < 2) return null;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'product-gallery-dots';
    dotsWrap.setAttribute('role', 'tablist');

    var buttons = [];

    slides.forEach(function (slide, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className =
        'product-gallery-dots__dot' + (slide.classList.contains('is-active') ? ' is-active' : '');
      button.setAttribute('aria-label', 'Show image ' + (index + 1));
      button.addEventListener('click', function () {
        if (typeof mediaGallery.setActiveMedia === 'function') {
          mediaGallery.setActiveMedia(slide.dataset.mediaId, false);
        }
      });
      dotsWrap.appendChild(button);
      buttons.push(button);
    });

    var sliderButtons = viewer.querySelector('.slider-buttons');
    if (sliderButtons && sliderButtons.parentElement) {
      sliderButtons.parentElement.insertBefore(dotsWrap, sliderButtons.nextSibling);
    } else {
      mediaGallery.appendChild(dotsWrap);
    }

    return { slides: Array.from(slides), buttons: buttons };
  }

  function syncDots(state) {
    if (!state) return;
    state.slides.forEach(function (slide, index) {
      state.buttons[index].classList.toggle('is-active', slide.classList.contains('is-active'));
    });
  }

  // Removes Shopify's default (scroll-based) click handling from a button by
  // swapping it for an identical clone with no listeners attached.
  function stripDefaultHandlers(button) {
    var clone = button.cloneNode(true);
    button.parentNode.replaceChild(clone, button);
    return clone;
  }

  // Makes the main image's prev/next arrows jump directly to the next/prev
  // thumbnail's media instead of trying to scroll (which does nothing once
  // inactive slides are hidden by the thumbnail-driven layouts).
  function wireArrows(mediaGallery, viewer, dotsState) {
    var thumbnails = mediaGallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbnails) return;

    var thumbButtons = Array.from(thumbnails.querySelectorAll('[data-target]'))
      .map(function (item) {
        return item.querySelector('button');
      })
      .filter(Boolean);
    if (thumbButtons.length < 2) return;

    var prev = viewer.querySelector('.slider-buttons .slider-button--prev');
    var next = viewer.querySelector('.slider-buttons .slider-button--next');
    if (!prev || !next) return;

    prev = stripDefaultHandlers(prev);
    next = stripDefaultHandlers(next);
    prev.removeAttribute('disabled');
    next.removeAttribute('disabled');

    function currentIndex() {
      for (var i = 0; i < thumbButtons.length; i++) {
        if (thumbButtons[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    function goTo(step) {
      var index = currentIndex() + step;
      if (index < 0) index = thumbButtons.length - 1;
      if (index >= thumbButtons.length) index = 0;
      thumbButtons[index].click();
    }

    prev.addEventListener('click', function (event) {
      event.preventDefault();
      goTo(-1);
    });

    next.addEventListener('click', function (event) {
      event.preventDefault();
      goTo(1);
    });
  }

  function initGallery(mediaGallery) {
    if (mediaGallery.dataset.overlayInit === 'true') return;

    var viewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    mediaGallery.dataset.overlayInit = 'true';

    var dotsState = buildDots(mediaGallery, viewer);
    wireArrows(mediaGallery, viewer, dotsState);

    if (dotsState) {
      var observer = new MutationObserver(function () {
        syncDots(dotsState);
      });
      dotsState.slides.forEach(function (slide) {
        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();